import Script from 'next/script';
import { getEyeAbleDomain } from './getEyeAbleDomain';

const EyeAbleScript = () => {
  const domain = getEyeAbleDomain();

  if (!domain) return null;

  return (
    <>
      <Script async src={`/eyeable/configs/${domain}.js`} />
      <Script async src="/eyeable/public/js/eyeAble.js" />
    </>
  );
};

export default EyeAbleScript;
